/**
 * Mounted once so the personalized queries are in flight before the cards
 * render. Each surface adds its own prefetch call as it lands; until then
 * there is nothing to fetch.
 */
export const PersonalizedContentPrefetch = () => null;
//# sourceMappingURL=PersonalizedContentPrefetch.js.map